<template>
    <li class="is-sidebar-summary-item">
        <div class="sidebar-badge-container">
            <e-tooltip v-if="label" :label="label" position="is-right">
                <router-link v-if="to" :id="id" :to="to" class="tw:text-[var(--text-color)]!" :aria-label="label">
                    <e-icon class="tw:relative tw:top-1" :icon="icon" />
                </router-link>
                <div v-else class="tw:text-[var(--text-color)]!" @click="$emit('open')">
                    <e-icon class="tw:relative tw:top-1" :icon="icon" />
                </div>
            </e-tooltip>
            <div v-else>
                <router-link v-if="to" :id="id" :to="to" class="tw:text-[var(--text-color)]!">
                    <e-icon class="tw:relative tw:top-1" :icon="icon" />
                </router-link>
                <div v-else class="tw:text-[var(--text-color)]!" @click="$emit('open')">
                    <e-icon class="tw:relative tw:top-1" :icon="icon" />
                </div>
            </div>
            <div v-if="hasBadge" class="sidebar-badge">
                {{ badgeCount }}
            </div>
        </div>

        <small v-if="title" class="is-sidebar-summary-item-title">
            {{ title }}
        </small>
    </li>
</template>

<script>
export default {
    name: 'AppSidebarSummaryItem',

    props: {
        label: {
            default: null,
            type: String,
        },
        id: {
            type: String,
            required: false,
            default: '',
        },
        type: {
            default: null,
            type: String,
        },
        icon: {
            default: null,
            type: String,
        },
        title: {
            default: null,
            type: String,
        },
        to: {
            default: null,
            required: false,
            validator: prop => typeof prop === 'object' || prop === null,
        },
        hasBadge: {
            default: false,
            type: Boolean,
        },
        badgeCount: {
            default: 0,
            type: Number,
        },
    },

    emits: ['open'],
};
</script>

<style lang="scss" scoped>
@import 'resources/scss/toolbox.scss';

.sidebar-badge-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: visible !important;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: background-color 0.2s ease;
}

.sidebar-badge-container:has(.router-link-exact-active) {
    background-color: var(--p-primary-color);
    opacity: 0.8;

    .e-icon,
    svg,
    i {
        color: white !important;
        fill: white !important;
    }
}

.sidebar-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    border-radius: 12px;
    background: var(--primary-color);
    color: white;
    font-weight: bold;
    height: 18px;
    font-size: 10px;
    text-align: center;
    line-height: 18px;
    min-width: 18px;
    padding: 0 3px;
    z-index: 1;
}

.is-sidebar-summary-item {
    // Also handle non-link items with click handlers
    .sidebar-badge-container:not(:has(.router-link-active)):hover {
        background-color: var(--p-primary-50);

        opacity: 0.8;

        .e-icon,
        svg,
        i {
            color: var(--text-color);
            fill: var(--text-color);
        }
    }

    .button {
        &.is-primary,
        &.is-primary-light,
        &.is-primary-dark {
            background-color: var(--primary-color) !important;
            border-color: var(--primary-color) !important;
            color: white !important;

            &:hover,
            &:focus,
            &:active,
            &.router-link-active {
                background-color: var(--primary-color) !important;
                border-color: var(--primary-color) !important;
                opacity: 0.9;
            }
        }
    }

    .button.is-primary,
    .button.is-primary-light,
    .button.is-primary-dark {
        .e-icon,
        svg,
        i {
            color: white !important;
            fill: white !important;
        }
    }
}
</style>
